<template>
    <div class="loginhome_wrap">
        <van-nav-bar
                title=""
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div class="loginhome_top">
            <div class="loginhome_banner">
                <img src="../../assets/img/loginhome_banner.png" />
            </div>
        </div>


        <div class="loginhome_cont">

            <div class="verifycode_form">
                <div class="verifycode_items" :class="isWarn ? 'verifycode_items_scale-1px' : 'border-1'">
                    <div class="verifycode_item">
                        <div class="verifycode_ioneleft">
                            <img src="../../assets/img/loginhome_icon01.png" />
                        </div>
                        <div class="verifycode_ionecenter">
                            <span>+52</span>
                        </div>
                        <div class="verifycode_ioneright">
                            <input type="number" @input="onMobile" v-model="mobile" placeholder="Ingresa tu celular" >
                        </div>
                    </div>
                </div>

                <div class="verifycode_fwran_view">
                    <template v-if="mobileVerify">
                        Formato incorrecto del número de teléfono
                    </template>
                    <template v-else>
                        <template v-if="isVerGoogtoken">
                            Realiza la verificación de seguridad
                        </template>
                        <template v-if="varSmscode">
                            Ingresa el código correcto
                        </template>
                    </template>
                </div>

                <div class="verifycode_google_wrap">
                    <div class="verifycode_google_cont" id="verifycode_google_cont">

                    </div>
                </div>
            </div>

            <div class="verifycode_footer_btns" @click="verificationCode">
                <div class="verifycode_footer_btn">
                    <van-button :loading="isLoading" round color="#19A95C" block style="height: 1.222222rem;">
                        <span style="font-weight: 500;">RECIBIR DINERO AHORA</span>
                    </van-button>
                </div>
            </div>

            <div class="verifycode_footer_xys">
                <div class="verifycode_footer_xy">
                    Ya eres usuario de Superapoyomax y abre APP
                </div>
            </div>


            <div class="verifycode_footer_ysview">
                <div class="verifycode_footer_ys">
                    Registrarse significa aceptar <span @click="gotoProvision">Términos y condiciones</span> y <span @click="gotoPrivacy">Aviso de privacidad</span> de Superapoyomax.
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    //import axios from 'axios'

    import { Toast, Dialog } from 'vant';
    import { loadingHide } from '@/utils/loading'

    //let apiHead = '';

    export default{
        data() {
            return {
                isSendcode: false,
                isWarn: false,
                mobile: null,
                mobileVerify: false,
                smscode: null,
                googleSucctoken: null,
                isVerGoogtoken: false,
                varSmscode: false,
                isLoading: false,
                commonparams: null,
            }
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            gotoPrivacy() {
                this.$router.push({
                    path: '/loanpage/privacidad'
                })
            },
            gotoProvision() {
                this.$router.push({
                    path: '/loanpage/provision'
                })
            },
            onMobile(){
                //console.log(this.mobile)
                let getmobile = this.mobile;

                let firstStr = getmobile.substr(0, 1);

                if(firstStr == 1){ //1开始 11位

                    if(getmobile.length > 11){
                        this.mobile = getmobile.substr(0, 11);
                    }

                } else {//非1 10位
                    if(getmobile.length > 10){
                        this.mobile = getmobile.substr(0, 10);
                    }
                }
            },
            verificationCode() {
                //let _this = this;

                if(this.mobile){
                    //console.log(111111)
                    let getmobile = this.mobile;

                    let firstStr = getmobile.substr(0, 1);

                    let isflag = false;

                    if(firstStr == 1){ //1开始 11位
                        if(getmobile.length == 11){
                            isflag = true;
                        } else {
                            isflag = false;
                        }

                    } else {//非1 10位
                        if(getmobile.length == 10){
                            isflag = true;
                        } else {
                            isflag = false;
                        }
                    }

                    if(isflag){
                        this.mobileVerify = false;

                        //let usemobile = `+52${this.mobile}`;
                        let usemobile = this.mobile;
                        //console.log('校验通过')
                        //console.log(usemobile)

                        // this.getCommomParams()
                        //
                        // this.isWarn = false;
                        // this.isVerGoogtoken = false;

                        /*if(this.googleSucctoken){
                            //let usemobile = `+52${this.mobile}`;
                            //console.log('校验通过')
                            //console.log(usemobile)

                            //this.getCommomParams()

                            //this.isWarn = false;
                            //this.isVerGoogtoken = false;
                        } else {
                            this.isWarn = true;
                            this.isVerGoogtoken = true;
                        }*/

                        console.log('sdeeffss')

                        this.$router.push({
                            path: '/loanpage/loginverify',
                            query: {
                                mobile: usemobile
                            }
                        })

                    } else {
                        loadingHide()
                        this.isWarn = true;
                        this.mobileVerify = true;
                        //Toast('Formato incorrecto del número móvil') //手机号码格式错误
                    }

                } else {
                    loadingHide()
                    Toast('Por favor ingrese el número de teléfono móvil') //请输入手机号
                }
            },
            goLogin() {
                Dialog.confirm({
                    title: '',
                    message: '¡Ya eres un usuario antiguo de Superapoyomax, abre APP para renovar tu préstamo!',
                    cancelButtonColor: '#19A95C',
                    cancelButtonText: 'OK',
                    confirmButtonColor: '#FFFFFF',
                    confirmButtonText: 'ABRE APP',
                })
                    .then(() => {
                        // on confirm
                        console.log('on confirm')
                        //window.location.href = 'https://superapoyo.onelink.me/IBEC/u6xtuvof'
                        this.jumpGPDownload();
                    })
                    .catch(() => {
                        console.log('on cancel')
                        // on cancel
                    });
            },
        }

    }
</script>

<style less scoped>
    .loginhome_wrap{
        width: 100%;
        height: auto;
    }
    .loginhome_top{
        width: 100%;
        height: auto;
        background: #F6F6F6;
    }
    .loginhome_banner{
        width: 92.22%;
        height: auto;
        padding-bottom: 0.888889rem;
        padding-top: 0.388889rem;
        margin: 0 auto;
    }
    .loginhome_banner img{
        display: block;
        width: 100%;
    }
    .loginhome_cont{
        width: 100%;
        height: auto;
        background: #ffffff;
        border-radius: 0.444444rem 0.444444rem 0px 0px;
        box-sizing: border-box;
        padding: 0.555556rem 0.388889rem 0.388889rem 0.388889rem;
    }

    .border-1 {
        position: relative;
    }

    .border-1:after {
        content: ' ';
        pointer-events: none;
        box-sizing: border-box;
        -webkit-transform-origin: 0 0;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        /* 多加 0.1%，能解决有时候边框缺失的问题 */
        width: 199.8%;
        height: 199.7%;
        transform: scale(0.5, 0.5);
        border: 0px solid #999999;
        z-index: 2;
    }

    .border-1:after {
        border-width: 1px;
        border-radius: 0.333333rem
    }

    .verifycode_items_scale-1px{
        position: relative;
    }
    /*.verifycode_items_scale-1px:after{
        content: ' ';
        pointer-events: none;
        box-sizing: border-box;
        -webkit-transform-origin: 0 0;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        !* 多加 0.1%，能解决有时候边框缺失的问题 *!
        width: 199.8%;
        height: 199.7%;
        transform: scale(0.5, 0.5);
        border: 0px solid #FB4840;
        z-index: 2;
    }*/
    /*.verifycode_items_scale-1px:after {
        border-width: 1px;
        border-radius: 0.333333rem
    }*/

    .verifycode_form{
        width: 100%;
        height: 4.75rem;
        margin: 0 auto;
    }
    .verifycode_items{
        width: 100%;
        height: 1.25rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    .verifycode_item{
        width: 100%;
        height: 1.25rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .verifycode_ioneleft{
        width: 1.111111rem;
        height: 1.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .verifycode_ioneleft img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .verifycode_ionecenter{
        width: 1.0rem;
        height: 1.25rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .verifycode_ionecenter span{
        font-size: 14px;
        color: #000000;
    }
    .verifycode_ioneright{
        width: 6.777778rem;
        height: 1.25rem;
    }
    .verifycode_ioneright input{
        display: block;
        width: 100%;
        height: 1.25rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        background: #ffffff;
        padding: 0;
    }
    input::-webkit-input-placeholder {
        /* WebKit browsers，webkit内核浏览器 */
        color: #CFCFCF;
        font-size: 12px;
    }
    input:-moz-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    input::-moz-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    input:-ms-input-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    .verifycode_itemtwo{
        justify-content: space-between;
    }
    .verifycode_itwoleft{
        width: 4.0rem;
        height: 1.166667rem;
    }
    .verifycode_itwoleft input{
        display: block;
        width: 100%;
        height: 1.1rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
        background: #ffffff;
        padding-left: 0;
    }
    .verifycode_itworight{
        width: auto;
        height: 0.75rem;
        background: #00CA88;
        border-radius: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: 0 0.13rem;
    }
    .verifycode_itworight.active{
        background: #CFCFCF;
    }
    .verifycode_itworight #sendcode{
        width: auto;
        min-width: 2.4rem;
        display: block;
        height: auto;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        outline: none;
        border: none;
        margin: 0 auto;
        background: #00CA88;
    }
    .verifycode_itworight #sendcode.active{
        background: #CFCFCF;
    }
    .verifycode_fwran_view{
        width: 100%;
        height: 20px;
        padding-top: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #FB4840;
    }
    .verifycode_google_wrap{
        width: 100%;
        height: 2.5rem;
        display: flex;
        justify-content: center;
        padding-top: 6px;
    }
    .verifycode_google_cont{
        width: 100%;
        height: auto;
        margin: 0 auto;
        display: flex;
        justify-content: center;
    }
    .verifycode_footer_btns{
        width: 100%;
        height: 1.555556rem;
    }
    .verifycode_footer_btn{
        width: 91.11%;
        height: 1.222222rem;
        margin: auto;
    }
    .verifycode_footer_xys{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
    }
    .verifycode_footer_xy{
        font-size: 14px;
        transform: scale(0.9);
        font-weight: 400;
        color: #00CA88;
    }
    .verifycode_footer_xy span{
        text-decoration: underline;
    }
    .verifycode_footer_ysview{
        width: 90%;
        height: auto;
        padding-top: 1.388889rem;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 0.444444rem;
        margin: 0 auto;
        text-align: center;
    }
    .verifycode_footer_ysview span{
        color: #333333;
        text-decoration: underline;
    }
    .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
</style>

<style less>
    .hide{
        display: none!important;
    }
    .potato_loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
    }
    .potato_loading_zhe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(0,0,0,0.6);
        opacity: 0;
        transition: opacity 0.4s ease;
    }
    .potato_loading_zhe_tr{
        opacity: 1!important;
    }
    .potato_loading1{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.4s ease;
    }
    .potato_loading1_Icon {
        width: 40px;
        height: 40px;
        margin: 0;
        background: transparent;
        border-top: 3px solid #9FB5DE;
        border-right: 3px solid transparent;
        border-radius: 50%;
        -webkit-animation: 1s spin linear infinite;
        animation: 1s spin linear infinite;
    }
    .potato_loading1_title{
        font-size: 14px;
        color: #9FB5DE;
    }
    .potato_loading3_title{
        display: inline-block;
        padding: 10px 14px;
        border-radius: 10px;
        background-color: rgba(0,0,0,0.8);
        color: #fff;
        max-width: 80%;
        line-height: 0.44rem;
    }
    @keyframes spin{
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>